import { useState, useRef } from "react";
import api from "../../lib/api";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { MapPin } from "lucide-react";

const Dropdown = ({ children, z = "z-20" }) => (
  <div className={`absolute ${z} mt-1 w-full bg-white border border-slate-200 rounded-md shadow-lg max-h-60 overflow-auto`}>{children}</div>
);

// Ricerca nell'archivio interno Enti/Indirizzi.
export const EnteSearch = ({ prefix, onPick }) => {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [show, setShow] = useState(false);
  const search = async (val) => {
    setQ(val);
    if (!val.trim()) { setResults([]); setShow(false); return; }
    try {
      const { data } = await api.get("/locations", { params: { q: val } });
      setResults(data); setShow(true);
    } catch { setResults([]); }
  };
  const pick = (loc) => {
    onPick(loc);
    setQ(loc.citta ? `${loc.citta} — ${loc.indirizzo}` : loc.indirizzo);
    setShow(false);
  };
  return (
    <div className="md:col-span-2 relative">
      <Label className="nx-label">Richiama Ente / Indirizzo</Label>
      <Input data-testid={`${prefix}-search`} value={q} autoComplete="off" placeholder="Cerca per città, indirizzo o reparto..."
        onChange={(e) => search(e.target.value)} onFocus={() => { if (results.length) setShow(true); }} className="mt-1.5" />
      {show && results.length > 0 && (
        <Dropdown>
          {results.map((loc) => (
            <button type="button" key={loc.id} data-testid={`${prefix}-option-${loc.id}`} onMouseDown={(e) => { e.preventDefault(); pick(loc); }}
              className="w-full text-left px-3 py-2 hover:bg-slate-50 text-sm border-b border-slate-100 last:border-0">
              <span className="font-medium text-slate-800">{loc.citta || "—"}</span>
              <span className="text-slate-400"> · {loc.indirizzo || "—"}{loc.reparto_citofono ? ` · ${loc.reparto_citofono}` : ""}</span>
            </button>
          ))}
        </Dropdown>
      )}
    </div>
  );
};

// Autocompletamento Google Places (debounced) sull'indirizzo completo.
export const GoogleIndirizzo = ({ prefix, value, onChange, onPlace }) => {
  const [res, setRes] = useState([]);
  const [show, setShow] = useState(false);
  const timer = useRef(null);
  const search = (val) => {
    onChange(val);
    if (timer.current) clearTimeout(timer.current);
    if (val.trim().length < 3) { setRes([]); setShow(false); return; }
    timer.current = setTimeout(async () => {
      try {
        const { data } = await api.get("/maps/autocomplete", { params: { q: val } });
        setRes(data); setShow(data.length > 0);
      } catch { setRes([]); setShow(false); }
    }, 350);
  };
  const pick = async (s) => {
    if (timer.current) clearTimeout(timer.current);
    setShow(false); setRes([]);
    try {
      const { data } = await api.get("/maps/place", { params: { place_id: s.placeId, text: s.text } });
      onPlace(data, s);
    } catch { onPlace(null, s); }
  };
  return (
    <div className="md:col-span-2 relative">
      <Label className="nx-label">Indirizzo Completo</Label>
      <Input data-testid={`${prefix}-indirizzo`} value={value} autoComplete="off" placeholder="Digita per l'autocompletamento Google Maps..."
        onChange={(e) => search(e.target.value)} onFocus={() => { if (res.length) setShow(true); }}
        onBlur={() => setTimeout(() => setShow(false), 150)} className="mt-1.5" />
      {show && res.length > 0 && (
        <Dropdown z="z-30">
          {res.map((s) => (
            <button type="button" key={s.placeId} data-testid={`${prefix}-gopt`} onMouseDown={(e) => { e.preventDefault(); pick(s); }}
              className="w-full text-left px-3 py-2 hover:bg-slate-50 text-sm border-b border-slate-100 last:border-0 flex items-center gap-2">
              <MapPin className="h-3.5 w-3.5 text-primary shrink-0" /> {s.text}
            </button>
          ))}
        </Dropdown>
      )}
    </div>
  );
};
